export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f7803d8a00d1bb95ff54dd24334150401060a04e0&name=fetchTypeahead!'